import { ChainType } from '@ankr.com/chains-list';
import { t } from '@ankr.com/common';

import { Tab } from 'modules/common/hooks/useTabs';

export const getChainTypeTabs = (): Tab<ChainType>[] => [
  {
    id: ChainType.Mainnet,
    title: t('chain-item.chain-types.mainnet'),
  },
  {
    id: ChainType.Testnet,
    title: t('chain-item.chain-types.testnet'),
  },
  {
    id: ChainType.Devnet,
    title: t('chain-item.chain-types.devnet'),
  },
  {
    id: ChainType.Signet,
    title: t('chain-item.chain-types.signet'),
  },
];
